import { combineReducers } from 'redux';
import fetching from './fetching';

export default combineReducers({
	fetching
});
